/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query LCRRoutePlanReadQuery($routeId: ID!, $take: PositiveInt, $skip: Int) {
    LCRRoutePlanRead(routeId: $routeId, take: $take, skip: $skip) {
      id
      createdAt
      updatedAt
      message
      status,
      _totalCount,
      LCRRoute {
        id
        displayName
      }
      VendorAccounttDirectory {
       id,
       displayName
      }
      VendorAccountt {
        id,
        VendorAccount {
          id,
          displayName
        }
      } 
    }
  }
`
